module.exports = __webpack_public_path__ + "static/img/05.9cc986bf.png";